(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("browser-sdk", [], factory);
	else if(typeof exports === 'object')
		exports["browser-sdk"] = factory();
	else
		root["browser-sdk"] = factory();
})(window, function() {
return 